/* eslint-disable */
import { AppSettingCacheMixin } from "./AppSettingCacheMixin"

export const SiteBookingResourceOrderSettingCacheMixin = {
    mixins: [AppSettingCacheMixin],
    computed: {
        settingKey() {
            return 'BookingResourceOrder';
        },
        defaultSettingObject() {
            return {
                forNewClients: [],
                forRegisteredClients: []
            }
        }
    }
}
